import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-44e1646c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "software-card"
};
const _hoisted_2 = {
  style: {
    "height": "75px"
  }
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "padding-top": "20px",
    "padding-left": "22px"
  }
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "software-name"
};
const _hoisted_6 = ["title"];
const _hoisted_7 = {
  key: 0,
  class: "span-icon-online"
};
const _hoisted_8 = {
  key: 1,
  class: "span-icon-offline"
};
const _hoisted_9 = {
  class: "software-change"
};
const _hoisted_10 = {
  style: {
    "height": "70px",
    "padding-top": "20px"
  }
};
const _hoisted_11 = {
  class: "software-card-status"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Commercial = _resolveComponent("Commercial");
  const _component_StateCard = _resolveComponent("StateCard");
  const _component_t_button = _resolveComponent("t-button");
  return _openBlock(), _createElementBlock("div", null, [_ctx.userCommercial && _ctx.comData.commercial ? (_openBlock(), _createBlock(_component_Commercial, {
    key: 0,
    style: {
      "position": "absolute"
    }
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    class: "software-logo",
    src: _ctx.comData.softwareLogo
  }, null, 8, _hoisted_4), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
    class: "software-name-title",
    title: _ctx.comData.softwareName
  }, _toDisplayString(_ctx.htmlRestore(_ctx.comData.softwareName)), 9, _hoisted_6), _ctx.onlineState == 3 || _ctx.onlineState == 4 ? (_openBlock(), _createElementBlock("div", _hoisted_7, " • 已上线 ")) : (_openBlock(), _createElementBlock("div", _hoisted_8, "• 未上线"))]), _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.moment(_ctx.comData.updateTime).format('YYYY-MM-DD')) + " 更新内容 ", 1)])])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_StateCard, {
    versions: _ctx.comData.versions,
    types: _ctx.comData.softwareState,
    updateTime: _ctx.comData.updateTime
  }, null, 8, ["versions", "types", "updateTime"])]), _createElementVNode("div", null, [_createVNode(_component_t_button, {
    class: "software-card-button",
    onClick: _ctx.btnClick
  }, {
    default: _withCtx(() => [_createTextVNode("查看详情")]),
    _: 1
  }, 8, ["onClick"])])])])]);
}